import { useAtom } from 'jotai';
import { Navigate } from 'react-router';

import LoadingIndicator from '@/components/LoadingIndicator';
import { TICKET_DRAFT_STORAGE_KEY } from '@/constants/common';
import useAuth, { REDIRECT_STORAGE_KEY } from '@/hooks/Auth.hooks';
import { selectedOrganizationAtom } from '@/pages/Organizations';
import { checkPermissions } from '@/services/permissions';
import { userAtom } from '@/store/user.store';

export const Authenticate = () => {
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const [userData] = useAtom(userAtom);
  const { isLoading, isAuthenticated } = useAuth();

  // Show loader while checking authentication, getting token and validating user
  if (isLoading) return <LoadingIndicator isLoading />;

  // User is authenticated and should be redirected
  if (isAuthenticated) {
    // User is differnt from the last user, clear the ticket draft and set the new user email in session
    if (userData && sessionStorage.getItem('userEmail') !== userData.email) {
      sessionStorage.removeItem(TICKET_DRAFT_STORAGE_KEY);
      sessionStorage.setItem('userEmail', userData.email);
    }

    // defer clearing the redirect url due to double execution of react in dev mode
    setTimeout(() => {
      sessionStorage.removeItem(REDIRECT_STORAGE_KEY);
    }, 2000);

    // If user was on a page before being redirected to login, redirect them back to that page
    const redirectUrl = sessionStorage.getItem(REDIRECT_STORAGE_KEY);
    if (
      redirectUrl &&
      !redirectUrl.includes('/authenticate') &&
      !redirectUrl.includes('/logout')
    ) {
      return <Navigate to={redirectUrl} replace />;
    }

    const hasPermissions = checkPermissions(
      'tickets.read',
      userData,
      selectedOrganization
    );

    if (hasPermissions) {
      return <Navigate to="/dashboard" replace />;
    }
    return <Navigate to="/announcements" replace />;
  }

  return <Navigate to="/login" replace />;
};

export default Authenticate;
